/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionAdditionalPaymentData
 */
export interface SubscriptionAdditionalPaymentData {
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAdditionalPaymentData
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAdditionalPaymentData
     */
    netAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAdditionalPaymentData
     */
    vatAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAdditionalPaymentData
     */
    roundingAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAdditionalPaymentData
     */
    totalAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionAdditionalPaymentData
     */
    vatPercentage?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAdditionalPaymentData
     */
    reverseCharge?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionAdditionalPaymentData
     */
    isAdditionalPaymentNeeded?: boolean;
}

/**
 * Check if a given object implements the SubscriptionAdditionalPaymentData interface.
 */
export function instanceOfSubscriptionAdditionalPaymentData(value: object): value is SubscriptionAdditionalPaymentData {
    return true;
}

export function SubscriptionAdditionalPaymentDataFromJSON(json: any): SubscriptionAdditionalPaymentData {
    return SubscriptionAdditionalPaymentDataFromJSONTyped(json, false);
}

export function SubscriptionAdditionalPaymentDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionAdditionalPaymentData {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'netAmount': json['netAmount'] == null ? undefined : json['netAmount'],
        'vatAmount': json['vatAmount'] == null ? undefined : json['vatAmount'],
        'roundingAmount': json['roundingAmount'] == null ? undefined : json['roundingAmount'],
        'totalAmount': json['totalAmount'] == null ? undefined : json['totalAmount'],
        'vatPercentage': json['vatPercentage'] == null ? undefined : json['vatPercentage'],
        'reverseCharge': json['reverseCharge'] == null ? undefined : json['reverseCharge'],
        'isAdditionalPaymentNeeded': json['isAdditionalPaymentNeeded'] == null ? undefined : json['isAdditionalPaymentNeeded'],
    };
}

export function SubscriptionAdditionalPaymentDataToJSON(json: any): SubscriptionAdditionalPaymentData {
    return SubscriptionAdditionalPaymentDataToJSONTyped(json, false);
}

export function SubscriptionAdditionalPaymentDataToJSONTyped(value?: SubscriptionAdditionalPaymentData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'netAmount': value['netAmount'],
        'vatAmount': value['vatAmount'],
        'roundingAmount': value['roundingAmount'],
        'totalAmount': value['totalAmount'],
        'vatPercentage': value['vatPercentage'],
        'reverseCharge': value['reverseCharge'],
        'isAdditionalPaymentNeeded': value['isAdditionalPaymentNeeded'],
    };
}

